/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
// eslint-disable-next-line object-curly-newline
import {
  Grid,
  Container,
  Typography,
  Box,
  Button,
  Paper,
  TextField,
} from '@material-ui/core';
import updateState from '../../actions/updateState';
import translate from '../../actions/translate';
import HavePromo from './HavePromo';
import RestaurantCard from './RestaurantCard';
import ErrorMessage from './ErrorMessage';
import DesignAndLanguages from '../../components/DesignAndLanguages';
import LogoAndStepper from '../../components/LogoAndStepper';
import TopLayer from '../../components/layers/TopLayer';
import MiddleLayer from '../../components/layers/MiddleLayer';
import BottomLayer from '../../components/layers/BottomLayer';
import ViewPortContainer from '../../components/layers/ViewPortContainer';
import TransitionButtons from '../../components/TransitionButtons';
import BoxContentContainer from '../../components/layers/BoxContentContainer';
// import Steppers from './Stepper';

export default function SeamlessForm() {
  // media query, on greater than iphone
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [restaurantText, setRestaurantText] = useState(' ');
  const language = useSelector((state) => state.formState.Page_language);
  const [zipcode, setZipcode] = useState("")
  const [times, setTimes] = useState(0);
  const [urlLanguage, urlSetLanguage] = useState(
    new URLSearchParams(window.location.search).get('language')
  );
  const [facebook, setFacebook] = useState(
    new URLSearchParams(window.location.search).get('facebook')
  );
  const restaurantFound = useSelector(
    (state) => state.formState.Restaurant_found
  );
  const workWithUs = useSelector((state) => state.formState.alreadyWorkWithUs);
  const showRestaurantSearch = useSelector(
    (state) => state.formState.showRestaurantSearch
  );
  const restaurant = useSelector((state) => state.formState.Restaurant_found);

  const baseURL = useSelector((state) => state.formState.baseURL);

  const handleRestaurantSearch = async (search) => {
    dispatch(
      updateState({
        alreadyWorkWithUs: false,
      })
    );
    setTimes(times + 1);
    dispatch(updateState({ failedPromoCode: false }));
    setLoading(true);
    if (!search) {
      return;
    }

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const body = {
      q: search,
    };

    try {
      const res = await axios.post(
        `${baseURL}/utils/find-or-create-restaurant-by-gmb`,
        body,
        config
      );

      console.log('IDENTIFY RESTAURANT RES ', res);

      if (!res.data[0].disabled) {
        console.log('DISABLED KEY ', res.data[0].disabled);
        dispatch(updateState({ alreadyWorkWithUs: true }));
      }

      // console.log(res);
      // setDisabled(res.data[0].disabled);
      setLoading(false);
      dispatch(updateState({ failedRestaurantSearch: false }));
      console.log(res.data[0]);

      // console.log(res);
      dispatch(updateState({ menu_id: res.data[0].menus[0].id }));
      // eslint-disable-next-line no-underscore-dangle
      dispatch(updateState({ Restaurant_id: res.data[0]._id }));
      dispatch(updateState({ showRestaurantSearch: false }));
      dispatch(updateState({ Restaurant_found: res.data[0].name }));
      dispatch(updateState({ Restaurant_alias: res.data[0].alias }));
      dispatch(
        updateState({
          Restaurant_address: res.data[0].googleAddress.formatted_address,
        })
      );

      // dispatch(updateState({ Restaurant_alias: res.data[0].menus[0] }));
      dispatch(updateState({ Signup_type: 'nonPromo' }));
    } catch (e) {
      dispatch(
        updateState({
          alreadyWorkWithUs: false,
        })
      );
      setLoading(false);
      dispatch(updateState({ failedRestaurantSearch: true }));
      console.log('ENTERED FAIL CASE ', e);
    }
  };



  useEffect(() => {
    if (facebook) {
      dispatch(
        updateState({
          facebook: true,
        })
      );
    }
    console.log('SHOW RESTAURANT SEARCH ', showRestaurantSearch);
    if (urlLanguage && urlLanguage.toLowerCase() === 'chinese') {
      dispatch(
        updateState({
          Page_language: 'Chinese',
        })
      );
    }
  }, []);

  return (
    <ViewPortContainer>
      <TopLayer>
        <LogoAndStepper step={0} showStepper />
      </TopLayer>
      <MiddleLayer>
        <BoxContentContainer>
          <Typography variant="h4">
            {translate('Identify your restaurant.')}{' '}
          </Typography>
          <br />

          {!restaurant ? (
            <>
            <Typography variant="h6">
              {translate('Enter your restaurant name and zip code.')} &nbsp;
            </Typography>
          
            </>
            
          ) : null}

          {restaurantFound ? (
            <>
              <RestaurantCard times={times} />{' '}
            </>
          ) : (
            <>
            <Grid container spacing={2}>
              <Grid item xs={6}>
              <TextField
                color="primary"
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="promo"
                label="Restaurant Name"
                name="promo"
                autoComplete="email"
                autoFocus
                value={restaurantText}
                onChange={(e) => setRestaurantText(e.target.value)}
                
              />
              </Grid>
              <Grid item xs={6}>  <TextField
                color="primary"
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="promo"
                label="Zipcode"
                name="promo"
                autoComplete="email"
                value={zipcode}
                onChange={(e) => setZipcode(e.target.value)}
                
              />
              </Grid>

            </Grid>
            
             
              {loading ? (
                <Grid
                  container
                  alignContent="center"
                  alignItems="center"
                  justify="center"
                >
                  <CircularProgress />
                </Grid>
              ) : null}
              <Box mt={1}>
                {' '}
                <Button
                  onClick={() => handleRestaurantSearch(restaurantText.concat(" ").concat(zipcode))}
                  variant="contained"
                  color="primary"
                >
                  {translate('Enter')}
                </Button>
                <HavePromo setLoading={setLoading} />
              </Box>
            </>
          )}
          <Box mt={1}>
            {' '}
            <ErrorMessage loading={loading} times={times} />
          </Box>

          <TransitionButtons disabledNext={!restaurantFound || workWithUs} />
        </BoxContentContainer>
      </MiddleLayer>
      <BottomLayer>
        <DesignAndLanguages showLanguages={true} />
      </BottomLayer>{' '}
    </ViewPortContainer>
  );
}
